<div class="card-list">
	<p class="title-xs font-serra">Cartes du binder</p>
	<div class="view-switch">
		<!-- <span class="text-xs opacity-60 tracking-wide">Infos</span> -->
		<i class="fa-regular fa-bars-staggered"></i>
		<input [ngModel]="settings.options().cardInfo" (ngModelChange)="settings.toggle('cardInfo')" type="checkbox" class="ml-2 toggle toggle-primary" />
	</div>

</div>

@if(pages()){
	@for(page of pagesSorted(); track page.page.ident; let iPage=$index){
		<div class="element-show lgb-divider mb-4" [style.--i]="0">
			<div class="divider-element pr-4">
				<img [src]="binderS.getImgPageFinish(page.page)">
			</div>
			<div class="divider-element px-4">
			  	Page {{iPage+1}}
			</div>
			<div class="divider-element pl-4">
				<button (click)="scanService.enable('page', page.page.ident)" class="btn btn-primary btn-gradient litle-btn-gradient">
					<i class="fa-regular fa-plus-large"></i>
				</button>		
			</div>
		</div>
		<div class="card-container">
			@for(card of page.cards; track card.ident){
				<div [ngClass]="{'element-show': !fragment()}" class="item-card" [style.--i]="$index">
					<lgb-card-item 
						[share]="share()"
						[backHisto]="backHisto()"
						[card]="card"
						[reference]="getRefence(card.card)"
						[scan]="getScan(card.scan)"
						[lazy]="iPage>1"
						[infos]="settings.options().cardInfo"
					></lgb-card-item>
				</div>
			}
		</div>
	}
}
@else if(cards().length){
	<div class="card-container">
		@for(card of cards(); track card.ident){
			<div [ngClass]="{'element-show': !fragment()}" class="item-card" [style.--i]="$index">
				<lgb-card-item 
					[share]="share()"
					[backHisto]="backHisto()"
					[card]="card"
					[reference]="getRefence(card.card)"
					[scan]="getScan(card.scan)"
					[lazy]="$index>10"
					[infos]="settings.options().cardInfo"
				></lgb-card-item>
			</div>
		}
	</div>
}

@if(cards().length==0){
	<div class="card-container">
		<img src="img/skin/empty-card.svg"/>
		<div class="empty-container mb-4">
			<p class="subtitle mb-4">
				Cette liste est vide pour le moment.<br/>
				Ajoute des cartes pour les voir apparaître ici.
			</p>
			@if(uBinder() && admin()){
				<button (click)="scanService.enable('binder', uBinder().ident)" class="btn btn-primary btn-gradient mb-4">Commencer</button>
			}
		</div>
	</div>
}